// The OAuth consent step for the hj-porter MCP connector (hj-mcp repo). Supabase Auth sends the
// operator to /oauth/consent?authorization_id=…, and that id must survive a sign-in or MFA detour.

export const OAUTH_CONSENT_PATH = '/oauth/consent'

const RESUME_KEY = 'oauthConsentResume'

/** Remember the consent URL (query included) before the auth gate sends the operator elsewhere. */
export function stashConsentReturn(pathname: string, search: string): void {
  if (pathname === OAUTH_CONSENT_PATH) sessionStorage.setItem(RESUME_KEY, pathname + search)
}

/** The stashed consent URL, consumed once. Only ever a same-app consent path, never an open redirect. */
export function takeConsentReturn(): string | null {
  const stored = sessionStorage.getItem(RESUME_KEY)
  sessionStorage.removeItem(RESUME_KEY)
  return stored?.startsWith(`${OAUTH_CONSENT_PATH}?`) ? stored : null
}

/** Leaves the app for the OAuth client's callback. A seam, so tests can observe it. */
export function leaveForClient(url: string): void {
  window.location.assign(url)
}
